import React from 'react';
import './AccessibilityPolicypage.css';

const AccessibilityPolicypage = () => {
  return (
    <div className="AccessibilityPolicypage_container" dir="rtl">
      <h1 className="AccessibilityPolicypage_h1">תקנון נגישות - BuyTaxi</h1>
      <p className="AccessibilityPolicypage_p">עודכן לאחרונה: 2025</p>

      <section className="AccessibilityPolicypage_section">
        <h2 className="AccessibilityPolicypage_h2">הצהרת נגישות</h2>
        <p className="AccessibilityPolicypage_p">
          אתר BuyTaxi פועל מתוך מחויבות עמוקה לאפשר גישה שוויונית לכל משתמשיו. אנו מאמינים שלכל אדם, ללא קשר ליכולותיו הפיזיות, המנטליות או הטכנולוגיות, מגיעה האפשרות להשתמש ולהפיק תועלת מהשירותים הדיגיטליים המוצעים באתר. מטרתנו היא להנגיש את כלל התכנים, הכלים והפונקציות בצורה שתאפשר לכל אדם, לרבות אנשים עם מוגבלויות, לעשות בהם שימוש מלא.
        </p>
        <p className="AccessibilityPolicypage_p">
          האתר פותח תוך התחשבות בהנחיות הנגישות של ארגון ה-W3C ובהתאם להמלצות התקן הבינלאומי WCAG 2.1 ברמה AA. אנו מבצעים בדיקות נגישות שוטפות ומשפרים באופן מתמיד את הקוד, התכנים והתשתיות על מנת לשמור על רמה גבוהה של נגישות.
        </p>
      </section>

      <section className="AccessibilityPolicypage_section">
        <h2 className="AccessibilityPolicypage_h2">מאפייני הנגישות באתר</h2>
        <ul className="AccessibilityPolicypage_ul">
          <li className="AccessibilityPolicypage_li">שימוש בכפתור נגישות ייעודי המוצג על גבי כל עמוד באתר ומאפשר התאמות מיידיות של גודל טקסט, ניגודיות וצבעים.</li>
          <li className="AccessibilityPolicypage_li">יכולת ניווט באתר בעזרת מקלדת בלבד - כולל מעבר בין תפריטים, טפסים ולחצנים באמצעות מקש Tab ו-Shift+Tab.</li>
          <li className="AccessibilityPolicypage_li">תמיכה בשימוש בקוראי מסך והטמעה של תגיות ARIA לתיאורי כפתורים, קישורים ואלמנטים אינטראקטיביים.</li>
          <li className="AccessibilityPolicypage_li">שימוש בניגודיות צבעים גבוהה ו/או כהה לצרכי נוחות משתמש עם מגבלות ראייה.</li>
          <li className="AccessibilityPolicypage_li">התאמת מבנה האתר לגישה פשוטה וברורה, עם כותרות היררכיות וקריאה ברורה של תכנים.</li>
          <li className="AccessibilityPolicypage_li">קיצורי מקשים נוחים לשימוש: Alt+N לפתיחת תפריט נגישות, Esc לסגירה, Tab לניווט קדימה ו-Shift+Tab לניווט אחורה.</li>
        </ul>
      </section>

      <section className="AccessibilityPolicypage_section">
        <h2 className="AccessibilityPolicypage_h2">תחזוקה ועדכונים שוטפים</h2>
        <p className="AccessibilityPolicypage_p">
          אנו מבצעים תחזוקה שוטפת למערכת האתר, כולל עדכונים לקוד ולתכנים, וזאת תוך הקפדה על בדיקות נגישות יסודיות לפני העלאת כל עדכון. אנו בוחנים גם את הפידבק מהמשתמשים על מנת לשפר את חוויית השימוש ולהתאים את הפתרונות לצרכים המשתנים.
        </p>
        <p className="AccessibilityPolicypage_p">
          כל פיתוח חדש באתר נבחן לא רק בהיבטים טכנולוגיים אלא גם ברמה האנושית – כיצד הוא ישפיע על הגישה והשימוש של אדם עם מגבלה. אנו עושים שימוש בכלים אוטומטיים ובבדיקות ידניות כחלק מתהליך הפיתוח.
        </p>
      </section>

      <section className="AccessibilityPolicypage_section">
        <h2 className="AccessibilityPolicypage_h2">פניות בנושא נגישות</h2>
        <p className="AccessibilityPolicypage_p">אם נתקלתם בקושי כלשהו בעת הגלישה באתר או שברצונכם להציע שיפור נגישות, אתם מוזמנים לפנות אלינו בכל עת:</p>
        <ul className="AccessibilityPolicypage_ul">
          <li className="AccessibilityPolicypage_li">שם: אמיר אטיאס הורי</li>
          <li className="AccessibilityPolicypage_li">טלפון: 050-2268395</li>
          <li className="AccessibilityPolicypage_li">אימייל: Amiratiashuri@gmail.com</li>
          <li className="AccessibilityPolicypage_li">זמן תגובה משוער: עד 7 ימי עסקים</li>
        </ul>
      </section>

      <section className="AccessibilityPolicypage_section">
        <h2 className="AccessibilityPolicypage_h2">התחייבות להמשך שיפור</h2>
        <p className="AccessibilityPolicypage_p">
          אנו מתחייבים להמשיך ולשפר את רמת הנגישות באתר מתוך מחויבות ערכית וחברתית כלפי כלל הציבור. מבחינתנו, נגישות היא לא דרישה חוקית בלבד – אלא שליחות חברתית אמיתית.
        </p>
        <p className="AccessibilityPolicypage_p">
          השאיפה שלנו היא לייצר סביבה דיגיטלית בה כל אדם, מכל רקע, יכול להרגיש שייך, מובן ומועצם. אם יש לכם הצעה, בקשה או הערה – נשמח לשמוע וליישם ככל שנוכל.
        </p>
      </section>

      <section className="AccessibilityPolicypage_section">
        <h2 className="AccessibilityPolicypage_h2">מדיניות פרטיות ונגישות</h2>
        <p className="AccessibilityPolicypage_p">
          לצד הנגישות, אנו מקפידים לשמור על פרטיות המשתמשים. כל מידע שתמסרו במסגרת פנייה בנושאי נגישות ישמר בסודיות מלאה, וישמש אך ורק לצורך טיפול בפנייה.
        </p>
        <p className="AccessibilityPolicypage_p">
          ניתן לפנות גם באופן אנונימי דרך טופס מקוון במערכת האתר. כל מידע אשר נצבר ישמש אותנו להפקת לקחים ולשיפור מתמיד של תהליך הנגישות.
        </p>
      </section>

    </div>
  );
};

export default AccessibilityPolicypage;